<template>
    <div v-if="dados">
        <!-- <draggable v-model="dados" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary" :draggable="search ? '.none' : '.list-group'"> -->
            <ul class="list-group az-anime-surgir" v-for="(categoria, icx) in dados" :key="icx">
                <li class="list-group-item">
                    <div class="d-flex justify-content-between">
                        <h5 :class="( categoria.expanded && categoria.categorias.length ) ? 'mb-2' : 'mb-0'">

                            <i class="fa-solid fa-equals text-primary fa-fw mr-2" v-if="categoria.fl_formula && categoria.fl_formula_consolid"></i>
                            <i class="fa-solid fa-square-root-variable text-primary fa-fw mr-2" v-else-if="categoria.fl_formula"></i>
                            <i class="fa-solid fa-folder-plus text-success fa-fw mr-2" v-else-if="categoria.ch_natureza == 'C' && !categoria.fl_permitir_lancamento && !categoria.fl_formula"></i>
                            <i class="fa-solid fa-folder-minus text-danger fa-fw mr-2" v-else-if="categoria.ch_natureza == 'D' && !categoria.fl_permitir_lancamento && !categoria.fl_formula"></i>
                            <i class="fa fa-plus-circle text-success fa-fw mr-2" aria-hidden="true" v-else-if="categoria.ch_natureza == 'C'"></i>
                            <i class="fa fa-minus-circle text-danger fa-fw mr-2" aria-hidden="true" v-else-if="categoria.ch_natureza == 'D'"></i>
                            <i class="fa-solid fa-circle-arrow-right text-primary fa-fw mr-2" aria-hidden="true" v-else-if="categoria.ch_natureza == 'T'"></i>

                            <a href="#" @click.prevent="selecionar(categoria)" class="card-link">
                                {{ categoria.search }}
                            </a>
                            
                            <span class="badge badge-secondary ml-2">#{{ categoria.id_categoria }}</span>
                            
                            <span class="badge badge-secondary ml-1" v-if="!categoria.fl_permitir_lancamento">
                                {{ contar(categoria) }}
                            </span>
                            <span v-if="categoria.fl_permitir_lancamento && categoria.fl_operacional" class="ml-3" title="Operacional">
                                <i class="fas fa-first-aid text-muted"></i>
                            </span>
                            <span v-if="categoria.fl_permitir_lancamento && categoria.fl_resultado" class="ml-3" title="Resultado (Receita/Despesa)">
                                <i class="fas fa-receipt text-muted"></i>
                            </span>
                            <span v-if="categoria.fl_formula" class="ml-3" title="Fórmula">
                                <i class="fa-solid fa-calculator text-muted"></i>
                            </span>
                            <!-- 
                                <span>{{ categoria.fl_ativa ? 'Ativa' : 'Inativa' }}</span>
                            -->
                        </h5>
                        <div class="custom-control custom-switch" v-if="view == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + categoria.id_categoria" 
                                v-model="categoria.fl_ativa" 
                                @change="toggle(categoria)">
                            <label class="custom-control-label" :for="'ativo-' + categoria.id_categoria"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary mr-3" title="Ordem">{{ categoria.num_ordem }}</span>

                            <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Editar Nível Hierárquivo"
                                @click.prevent="editar(categoria)">
                                <i class="fas fa-edit text-primary"></i>
                            </a>
                            <template v-if="!categoria.fl_permitir_lancamento && !categoria.st_formula">
                                <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Categoria"
                                    @click.prevent="incluir(categoria)">
                                    <i class="fas fa-plus text-success"></i>
                                </a>
                                <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Fórmula"
                                    @click.prevent="incluir(categoria, true)">
                                    <i class="fa-solid fa-square-root-variable"></i>
                                </a>
                                <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Sub Nível Hierárquico"
                                    @click.prevent="incluir_sub(categoria)">
                                    <i class="fas fa-folder-plus"></i>
                                </a>
                            </template>
                        </div>
                    </div>
                    <div v-if="categoria.expanded && !categoria.fl_permitir_lancamento">
                        <categoria-hierarquia 
                            :id_modelo_categoria="id_modelo_categoria"
                            class="mt-2" 
                            :value="categoria" 
                            :natureza="natureza"
                            :tipo_aplic="tipo_aplic"
                            :expansao="expansao"
                            v-if="categoria.categorias.length" 
                            :view="view" 
                            :search="search"
                            @expandir="expandir"
                            @refresh="refresh"
                            @editar="editar"
                            @toggle="toggle"
                            @incluir="incluir"
                            @incluir_sub="incluir_sub" />
                    </div>
                </li>
            </ul>
        <!-- </draggable> -->
    </div>
</template>

<script>
// import draggable from "vuedraggable";
import _ from 'lodash';

export default {
    data() { 
        return {
            drag: false, 
            dados: null, 
        };
    },

    name: 'categoria-hierarquia',

    props: ['value', 'view', 'search', 'natureza', 'expansao', 'tipo_aplic', 'id_modelo_categoria'], 

    components: { 
        // draggable,
    },

    watch: { 
        value: { 
            handler: function () {
                this.preparar();
            },
            deep: true,
            immediate: true
        },

        search: { 
            handler: function () {
                this.preparar();
            },
            deep: true,
            immediate: true
        },

        view: { 
            handler: function () {
                this.preparar();
            },
            deep: true,
            immediate: true
        }
    },

    computed: { 
        lista: { 
            get: function () { 
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                let lista = _.cloneDeep(this.dados.categorias);

                return lista.filter(item => this.view == 'T' || item.fl_ativa).filter(item => !this.search || reg.test(JSON.stringify(item)) );
                    //item => [item.ch_natureza, item.in_regra_ordem, item.id_categoria]
            },

            set: function (newValue) { 
                console.log('set', newValue);
            },
        },       
    },

    methods: { 
        contar(categoria) { 
            return this.view == 'T' ? categoria.categorias.length : categoria.categorias.filter(item => item.fl_ativa).length;
        },
        preparar () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');
            
            this.dados = _.cloneDeep(
                this.value.categorias.filter(item => ( item.ch_natureza == this.natureza || this.natureza == 'G' || item.id_categoria_mae ))
                    .filter(item => !this.tipo_aplic || this.tipo_aplic == 'G' || !isNaN(this.id_modelo_categoria)
                        || ( this.tipo_aplic == 'F' && !item.fl_sem_desembolso )  
                        || ( this.tipo_aplic == 'D' && item.fl_resultado )
                    )
                    .filter(item => this.view == 'T' || item.fl_ativa)
                    .filter(item => !this.search || reg.test(JSON.stringify(item)) )
                    .map(item => { 
                        if ( _.has(this.expansao, item.id_categoria) ) { 
                            item.expanded = this.expansao[item.id_categoria];
                        }

                        return item;
                    })
                );    
        },

        selecionar (item) { 
            if ( item.fl_permitir_lancamento ) { 
                this.editar(item);
                return;
            }

            item.expanded = !item.expanded

            this.expandir(item);
        },

        expandir(item) { 
            this.$emit('expandir', item);
        },

        refresh() { 
            this.$emit('refresh');
        },

        atualizarOrdem() { 
            let idx = 1;

            this.dados.forEach(item => {
                item.in_regra_ordem = ( ( item.ch_natureza == 'D' ? 1000 : 1 ) * (idx++) );
            });

            if ( isNaN(this.id_modelo_categoria) ) { 

                this.$util.atualizar(this, { 
                    service: 'categorias', 
                    func: 'ordem',
                    dados: {
                        lista: this.dados,
                    },
                    callback: () => { 
                        this.refresh();
                    }
                });

            }
        },

        toggle (item) { 
            this.$emit('toggle', item);

            /*
            this.$util.toggle(this, { 
                service: 'categorias',
                dados: item, 
            });
            */
        },

        editar (item) { 
            this.$emit('editar', item);
        },

        incluir (item, formula = false) {
            if ( formula ) { 
                item = _.cloneDeep(item);
                item.formula = formula;
            }
            
            this.$emit('incluir', item);
        },

        incluir_sub (item) { 
            this.$emit('incluir_sub', item);
        }
    }


}
</script>